import { InfoOutlined } from "@mui/icons-material";
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, Autocomplete, DialogActions, TextField, GridLegacy as Grid, Typography, InputLabel, Card, CardContent } from '@mui/material';
import { AxiosInstance, DialogType } from "../../utils/constants";
import DisabledByDefaultRoundedIcon from '@mui/icons-material/DisabledByDefaultRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useEffect, useState } from "react";



export const ModalConectorItems = ({
    isOpened,
    onSave,
    onClone,
    productInfo,
    disabled
})=>{

    const [itemsCompra,setItemsCompra] = useState([]);
    const [productOptions,setProductOptions] = useState([]);


    useEffect(()=>{
        if ( productInfo.items_compras ){
            setItemsCompra(productInfo.items_compras);
        }
        
    },[productInfo.items_compras]);

    
    const onSearchProducto = async (e,value_search) => {
        console.log({value_search});
        if (value_search) {
            try {
      
                const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
                    search_query: value_search
                });
                setProductOptions(value);
            } catch (e) {
                return [];
            }
      
        }
      
      
      
      }
      const onSetValueProduct = (e,value)=>{
        setItemsCompra(value);
      }

      const onSaveInfo = ()=>{
        onSave({
            cod_item_venta:productInfo.cod,
            items_compra:itemsCompra.map( ele=>ele.value )
        } );
      }

    return (
        <Dialog
        open={isOpened}
        >
            <DialogTitle>
               Asociacion de items
            </DialogTitle>
            <DialogContent>
                <Grid container  >
                    <Grid item sm={12} md={12} sx={12} >
                        <Card>
                            <CardContent>
                            <Typography variant="h6" fontSize='1.2rem' >
                            Item de venta seleccionado
                        </Typography>
                        <Typography variant="body1" > <strong>{productInfo.cod_erp}</strong> - {productInfo.descripcion}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                
                
                </Grid>
                <InputLabel>Seleccione los items de compra del producto</InputLabel>
                <Autocomplete  
                fullWidth
                disabled={disabled}
                value={itemsCompra}
                multiple={true}
                options={ productOptions|| []}
                noOptionsText="Lista vacia"
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                filterOptions={(x) => x}
                onInputChange={onSearchProducto}
                onChange={onSetValueProduct}
                renderInput={ (props)=> <TextField {...props}  />}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClone} size="small" variant="contained" color="secondary" sx={{marginRight:'4px'}}   >Cerrar</Button>
                <Button   disabled={disabled} onClick={onSaveInfo} size="small" variant="contained"  >Guardar</Button>
            </DialogActions>
        </Dialog>
    )

}